import React from 'react';
import Tooltip from '@mui/material/Tooltip';

import type { IMessage } from 'src/services/api';
import { EMessageDirection } from 'src/services/api';
import { ChannelIcon, getChannelLabel } from 'src/components/channel-icon';

import styles from 'src/pages/landlord/leads/messages/components/messages-container/MessageChannelBadge.module.css';

type Props = {
    message: IMessage;
}

/**
 * Shows which channel a single message travelled on, in the message bubble's
 * footer. The icon alone carries the channel; the tooltip spells it out on hover.
 */
export default function MessageChannelBadge({ message }: Props) {
    const verb = message.direction === EMessageDirection.IN ? 'Received' : 'Sent';

    return (
        <Tooltip title={`${verb} on ${getChannelLabel(message.channel)}`}>
            <span className={styles.badge} data-testid={`message-channel-${message.channel}`}>
                <ChannelIcon channel={message.channel} size={13} className={styles.icon} />
            </span>
        </Tooltip>
    );
}
